var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneSidebar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "192 382 30 30",
    style: {
      enableBackground: "new 192 382 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#127AE3"
    },
    d: "M219.383,401.613c-1.806,0-3.579-0.282-5.26-0.838c-0.823-0.281-1.836-0.023-2.338,0.493 l-3.317,2.504c-3.847-2.053-6.216-4.422-8.242-8.24l2.43-3.231c0.631-0.631,0.858-1.552,0.587-2.416 c-0.558-1.689-0.841-3.462-0.841-5.269c0-1.305-1.062-2.367-2.367-2.367h-5.418c-1.305,0-2.367,1.062-2.367,2.367 c0,14.961,12.172,27.133,27.133,27.133c1.305,0,2.367-1.062,2.367-2.367v-5.402C221.75,402.675,220.688,401.613,219.383,401.613z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneSidebar);
export default __webpack_public_path__ + "static/media/phone-sidebar.84696d40962bb4690784ead8326dc4a5.svg";
export { ForwardRef as ReactComponent };